import { ContentService } from '@blk/cwp-ng-framework';
import { ScenarioTesterDCR } from '@ddt-web/config';
import { CellData } from '@ddt-web/data-service';

import { ScenarioCategories } from '../models/scenarios.interface';

export class ScenarioCategoryUtil {

	private static readonly CATEGORY_DCR_KEY_SUFFIX = '_TITLE_DCR_KEY';
	private static readonly CATEGORY_DCR_VALUE_SUFFIX = '_TITLE_DCR_VALUE';

	public static getCategoryName(category: string = '', contentService: ContentService): string {
		const categoryNameKey = category.toUpperCase() + this.CATEGORY_DCR_KEY_SUFFIX;
		const categoryNameValue = category.toUpperCase() + this.CATEGORY_DCR_VALUE_SUFFIX;

		return contentService.get(categoryNameKey, ScenarioTesterDCR[categoryNameValue]);
	}

	/**
	 * Splits all scenarios into categories using ContentService
	*/
	public static getScenarioCategories(contentService: ContentService): ScenarioCategories {
		return {
			featured: contentService.get(ScenarioTesterDCR.CATEGORY_FEATURED_KEY, ScenarioTesterDCR.CATEGORY_FEATURED_VALUE).split(','),
			interest: contentService.get(ScenarioTesterDCR.CATEGORY_INTEREST_INFLATION_KEY, ScenarioTesterDCR.CATEGORY_INTEREST_INFLATION_VALUE).split(','),
			commodities: contentService.get(ScenarioTesterDCR.CATEGORY_COMMODITIES_KEY, ScenarioTesterDCR.CATEGORY_COMMODITIES_VALUE).split(','),
			equities: contentService.get(ScenarioTesterDCR.CATEGORY_EQUITIES_KEY, ScenarioTesterDCR.CATEGORY_EQUITIES_VALUE).split(','),
			bonds: contentService.get(ScenarioTesterDCR.CATEGORY_BONDS_CREDIT_KEY, ScenarioTesterDCR.CATEGORY_BONDS_CREDIT_VALUE).split(','),
			past: contentService.get(ScenarioTesterDCR.CATEGORY_PAST_FEATURED_KEY, ScenarioTesterDCR.CATEGORY_PAST_FEATURED_VALUE).split(',')
		};
	}

	/**
	 * Separate given scenarios into given categories
	*/
	public static categoriseScenarios(categorisedScenarioStrings: ScenarioCategories, scenarios: CellData[] = []): ScenarioCategories {
		const categories: ScenarioCategories = <ScenarioCategories>{};
		Object.entries(categorisedScenarioStrings).forEach(([cat0, cat1]) => (categories[cat0] = ScenarioCategoryUtil.getScenariosForCategory(cat1, scenarios)));
		return categories;
	}

	private static getScenariosForCategory(scenarioIds: string[], scenarios: CellData[]): CellData[] {
		return scenarios.filter((scenario: CellData) => scenarioIds.includes(scenario.rawValue.toString()));
	}

}
